import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { EPINIO_TYPES } from '../types';
import { useStore } from 'vuex';
import ResourceTable from '@shell/components/ResourceTable';
import { ref, onMounted, onUnmounted, computed, useAttrs } from 'vue';
import { startPolling, stopPolling } from '../utils/polling';


export default /*@__PURE__*/_defineComponent({
  __name: 'appcharts',
  props: {
    schema: {}
  },
  setup(__props: any) {

const pending = ref<boolean>(true);
const props = __props; //eslint-disable-line @typescript-eslint/no-unused-vars

const store = useStore();
const attrs = useAttrs();

onMounted(async () => {
  await store.dispatch(
    `epinio/findAll`,
    { type: EPINIO_TYPES.APP_CHARTS }
  );
  pending.value = false;
  startPolling(["appcharts"], store);
});

onUnmounted(() => {
  stopPolling(["appcharts"]);
});

const rows = computed(() => {
  return store.getters['epinio/all'](EPINIO_TYPES.APP_CHARTS);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ResourceTable), _mergeProps(_unref(attrs), {
    rows: rows.value,
    schema: _ctx.schema,
    loading: pending.value,
    "table-actions": false
  }), null, 16, ["rows", "schema", "loading"]))
}
}

})